/* visual list styles replaced, so we re-add semantics for some SRs */
/* eslint-disable jsx-a11y/no-redundant-roles */
import * as React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import IconBase from './Icon'

const ListContext = React.createContext()
const ListItemContext = React.createContext()

const IconList = React.forwardRef(
  (
    {
      children,
      className,
      spacing,
      iconColor = 'brightBlue',
      iconName = 'check-circle',
      iconSize = 1,
      ...props
    },
    ref
  ) => {
    return (
      <ul
        className={classnames('list-reset', spacing ? `spacing-${spacing}` : 'spacing', className)}
        role="list"
        {...props}
        ref={ref}
      >
        <ListContext.Provider
          value={{
            iconColor,
            iconName,
            iconSize,
          }}
        >
          {children}
        </ListContext.Provider>
      </ul>
    )
  }
)

const IconListItem = React.forwardRef(({ children, className, ...props }, ref) => {
  let context = React.useContext(ListContext)
  let {
    iconColor = context.iconColor,
    iconName = context.iconName,
    iconSize = context.iconSize,
    ...domProps
  } = props
  let iconProps = { name: iconName, color: iconColor, size: iconSize }
  return (
    <li className={classnames('icon-text', className)} {...domProps} ref={ref}>
      {typeof children === 'string' ? (
        <>
          <IconBase name={iconName} color={iconColor} size={iconSize} />
          <span>{children}</span>
        </>
      ) : typeof children === 'function' ? (
        children(iconProps)
      ) : (
        <ListItemContext.Provider value={iconProps}>{children}</ListItemContext.Provider>
      )}
    </li>
  )
})

function Icon(props) {
  const iconProps = React.useContext(ListItemContext)
  return <IconBase {...iconProps} {...props} />
}

const sharedPropTypes = {
  iconColor: PropTypes.oneOf(['green', 'blue', 'brightBlue']),
  // iconName: PropTypes.oneOf(['check-circle']),
  iconName: PropTypes.string,
  iconSize: PropTypes.number,
}

IconList.propTypes = {
  ...sharedPropTypes,
  spacing: PropTypes.oneOf(['small', null]),
}

IconListItem.propTypes = {
  ...sharedPropTypes,
}

Icon.propTypes = {
  name: sharedPropTypes.iconName,
  color: sharedPropTypes.iconColor,
  size: sharedPropTypes.iconSize,
}

IconList.displayName = 'IconList'
IconListItem.displayName = 'IconListItem'

export { IconList, IconListItem, Icon }
